import React from "react";
import TradesApprovedTableRow from "./TradesApprovedTableRow";
import EmptyState from "../../shared/helpers/EmptyState";

export default function TradesApprovedTable(props) {

  const requestResponsesData2 = props.requestResponsesData2?.shift_change_request_history || [];

  let tradesHistory = requestResponsesData2?.filter((v, i) => v?.shift_pickup_json !== null)

  const hasTradesHistory = tradesHistory.length > 0;


  return (
    <>
      {hasTradesHistory ? (
        <div className="mt-12">
          <div className="flex items-center px-6">
            <div className="flex-auto">
              <h1 className="text-xl font-bold text-slate-900">History</h1>
            </div>
          </div>
          <div className="mt-8 flex flex-col">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 min-w-full">
              <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-slate-100">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="w-[40%] py-3 pl-6 pr-3 text-left text-xs font-semibold text-slate-500"
                        >
                          Sender
                        </th>
                        <th
                          scope="col"
                          className="w-[14%] px-3 py-3"
                        >
                        </th>
                        <th
                          scope="col"
                          className="w-[40%] pr-6 py-3 text-left text-xs font-semibold text-slate-500"
                        >
                          Receiver
                        </th>
                        <th
                          scope="col"
                          className="w-[6%] relative py-3 pl-3 pr-6"
                        >
                          <span className="sr-only">Actions</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 bg-white">
                      {tradesHistory?.map((trade, index) => (
                        <TradesApprovedTableRow
                          key={index}
                          trade={trade}
                          archive_trade_request={props.archive_trade_request}
                          roleNames={props.roleNames}
                        />
                      ))}
                    </tbody>
                  </table>
                  <div className="border-b border-slate-100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <EmptyState
          title="History"
          description="No acted on trades at the moment"
        />
      )}
    </>
  );
}
